import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar } from "lucide-react";
import { useArticleContext } from "../../context/ArticleContext";
import { useEffect } from "react";

const LatestArticles = () => {
  const { articles, fetchArticles } = useArticleContext();

  useEffect(() => {
    fetchArticles();
  }, []);

  return (
    <section className="bg-[#fef8f5] py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#7a6e5f]">
          Read From Our Skincare Journal
        </h2>
        <p className="mt-4 text-[#7a6e5f] opacity-80 max-w-xl mx-auto">
          Skincare isn’t just about products — it’s about understanding your skin, one gentle step at a time.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {articles.slice(0, 3).map((article, index) => (
          // <motion.div
          //   key={article.id}
          //   initial={{ opacity: 0, y: 30 }}
          //   whileInView={{ opacity: 1, y: 0 }}
          //   transition={{ delay: index * 0.2 }}
          //   viewport={{ once: true }}
          //   className="bg-white rounded-xl shadow overflow-hidden group"
          // >
          //   <img
          //     src={`${process.env.REACT_APP_API_URL}/storage/${article.image}`}
          //     alt={article.title}
          //     className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-300"
          //   />
          //   <div className="p-6 text-left text-[#7a6e5f]">
          //     <div className="flex items-center gap-2 text-sm opacity-70 mb-2">
          //       <Calendar className="w-4 h-4" />
          //       {new Date(article.created_at).toLocaleDateString("en-GB")}
          //     </div>
          //     <h3 className="text-lg font-semibold mb-2">{article.title}</h3>
          //     <p className="text-sm opacity-80 line-clamp-3">{article.excerpt}</p>
          //   </div>
          // </motion.div>

          <motion.div
  key={article.id}
  initial={{ opacity: 0, y: 30 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ delay: index * 0.2 }}
  viewport={{ once: true }}
  className="bg-white rounded-xl shadow overflow-hidden group"
>
  <img
    src={`${process.env.REACT_APP_API_URL}/storage/${article.image}`}
    alt={article.title}
    className="w-full h-52 object-cover group-hover:scale-105 transition-transform duration-300"
  />
  <div className="p-6 text-left text-[#7a6e5f]">
    <div className="flex items-center gap-2 text-sm opacity-70 mb-2">
      <Calendar className="w-4 h-4" />
      {new Date(article.created_at).toLocaleDateString("en-GB")}
    </div>
    <h3 className="text-lg font-semibold mb-2">{article.title}</h3>
    <p className="text-sm opacity-80 line-clamp-3">{article.excerpt}</p>
    
    <div className="mt-4">
      <Link
        to={`/articles/${article.id}`}
        className="text-[#809080] font-medium hover:underline inline-flex items-center"
      >
        Read More
        <svg
          className="ml-1 w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7"></path>
        </svg>
      </Link>
    </div>
  </div>
</motion.div>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link
          to="/articles"
          className="inline-block bg-[#809080] text-white px-8 py-3 rounded-md hover:bg-[#6d7d6d] transition-colors font-medium"
        >
          Read More Articles
        </Link>
      </div>
    </section>
  );
};

export default LatestArticles;
